//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import adres from '~/graphql/queries/adres.gql';
import opleidingen from '~/graphql/queries/opleidingen.gql';
import opleidingsOrganisaties from '~/graphql/queries/opleidingsOrganisaties.gql';

const countries = require('i18n-iso-countries');
countries.registerLocale(require('i18n-iso-countries/langs/nl.json'));

export default {
  name: 'Stap1',
  props: {
    value: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  apollo: {
    opleidingen: {
      query: opleidingen,
    },
    opleidingsOrganisaties: {
      query: opleidingsOrganisaties,
    },
  },
  data: () => ({
    inBuitenland: false,
    opleidingen: [],
    opleidingsOrganisaties: [],
  }),
  computed: {
    opleidingenComputed() {
      return this.opleidingen.map((m) => { return {value: m.id, label: m.title}; });
    },
    opleidingsOrganisatiesComputed() {
      return this.opleidingsOrganisaties.map((m) => { return {value: m.id, label: m.title}; });
    },
    formData: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    countries() {
      const list = countries.getNames('nl', {select: 'official'});
      return Object.keys(list).map(key => ({value: key, label: list[key]}));
    },
  },
  methods: {
    getAddress() {
      if (!this.inBuitenland) {
        this.$nextTick(async function () {
          if (this.formData.huisnummer && this.formData.postcode && this.formData.postcode.length === 6) {
            await this.$apollo.query({
              query: adres,
              variables: {
                postcode: this.formData.postcode,
                huisnummer: this.formData.huisnummer,
              },
            }).then((data) => {
              if (data?.data?.adres) {
                const adres = data.data.adres;
                const newFormData = JSON.parse(JSON.stringify(this.formData));
                newFormData.adres = adres?.straat ? adres.straat : '';
                newFormData.plaats = adres?.plaats ? adres.plaats : '';
                this.$emit('setFormData', newFormData);
              }
            }).catch((err) => {
              console.log(err);
            });
          }
        });
      }
    },
    submit(data) {
      this.$emit('submit', data);
    },
  },
};
